import React, { Component } from "react";

import * as Icons from "@mui/icons-material";

class RewardShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rewards: [],
      currentRewardIndex: 0,
      isOpen: true,
    };

    this.interval = null;
  }

  componentDidMount() {
    const rewards = this.generateRewards(400);
    this.setState({ rewards });

    // Start timer to update reward every 20 seconds
    this.interval = setInterval(() => {
      this.setState((prevState) => {
        const nextIndex =
          prevState.currentRewardIndex + 1 < prevState.rewards.length
            ? prevState.currentRewardIndex + 1
            : 0; // loop back to start
        return { currentRewardIndex: nextIndex };
      });
    }, 10000); // 20 seconds
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  firstNames = [
    "Chinonso", "Aisha", "Tolu", "Ifeanyi", "Yetunde", "Emeka", "Fatima", "Segun",
    "Ngozi", "Kabir", "Uche", "Bola", "Chidera", "Hadiza", "Kunle", "Grace", "Efe",
    "Obinna", "Halima", "Ayodele", "Olamide", "Chisom", "Zainab", "Ibrahim", "Amaka"
  ];

  lastNames = [
    "Eze", "Bello", "Adebayo", "Nwosu", "Okonkwo", "Uche", "Basit", "Ajayi",
    "Ibekwe", "Salihu", "Okafor", "Balogun", "Onyeka", "Mohammed", "Akinwale",
    "Johnson", "Edafe", "Madu", "Aliyu", "Adetokunbo", "Olowo", "Nwachukwu",
    "Ahmed", "Opara"
  ];

  reasons = [
    "completing the 4th Investment Realm",
    "reaching the 6th Investment Realm milestone",
    "100% task completion in the 5th Investment Realm",
    "successful cultivation over 30 days",
    "surpassing 20 million total earnings",
    "completing the 3rd Investment Realm",
    "consistent cultivation and task completion",
    "achieving 90% task completion in the 4th Investment Realm",
    "completing the 7th Investment Realm",
    "maintaining a 60-day cultivation streak",
    "finishing 8th Investment Realm successfully",
    "achieving 80% task completion across all Realms",
    "reaching the 10th Investment Realm",
    "hitting 15 million in total system earnings",
    "achieving 70% task completion in the 6th Realm"
  ];

  getRandomName = () => {
    const first = this.firstNames[Math.floor(Math.random() * this.firstNames.length)];
    const last = this.lastNames[Math.floor(Math.random() * this.lastNames.length)];
    return `${first} ${last}`;
  };

  getRandomAmount = () => {
    const amount = Math.floor(Math.random() * (1500000 - 50000 + 1)) + 50000;
    return amount.toLocaleString('en-NG');
  };

  getRandomReason = () => {
    return this.reasons[Math.floor(Math.random() * this.reasons.length)];
  };

  generateRewards = (count = 400) => {
    const rewards = [];
    for (let i = 0; i < count; i++) {
      const name = this.getRandomName();
      const amount = this.getRandomAmount();
      const reason = this.getRandomReason();
      rewards.push(`${name}  received a total reward of ₦${amount} for ${reason}.`);
    }
    return rewards;
  };

  render() {
    const { rewards, currentRewardIndex, isOpen } = this.state;
    const currentMessage = rewards[currentRewardIndex] || "Loading rewards...";

    return (
      <div className={`rewardShow  p-3  animate__animated ${
        isOpen ? "animate__slideInRight" : "animate__slideOutRight"
      }`}  style={{backgroundColor:"#e8fff1"}}>
        <div
          className="animate__animated animate__faster animate__slideInRight"
        >
      

          <div className="reward-item p-3" style={{ fontSize: "14px", }}>
          <span
            style={{ right: "0px", top: "0px",  marginTop: "-10px", position: "absolute", cursor: "pointer" }}
            onClick={() => this.setState({ isOpen: false })}
          >
            <span className="material-symbols-outlined">close</span>
          </span>
            {currentMessage}

            <div className="mt-4">
            <a href="signin">
            <button className="btn btn-primary   py-2  d-flex"  style={{ minWidth: "150px" }}>
                      <span className="px-3 d-inline-block"> Start Earning </span> <Icons.Login/>
            </button>
            </a> 
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RewardShow;
